import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SmoothCollapse from 'react-smooth-collapse';

class CollapsibleContent extends Component
{
    state = {
        open: false
    };

    renderText = () =>
    {
        return (this.state.open) ? this.props.closeText : this.props.openText;
    };

    //---------------------------------------------------------------------------------------------------------------

    render = () => 
    {
        return (
            <div className="collapsible-segment">
                <p><a className="tap-event" onClick={ () => { this.setState({ open: !this.state.open }) } }>{ this.renderText() }</a></p>
                <SmoothCollapse expanded={ this.state.open }>
                    <div className="place-info-body" dangerouslySetInnerHTML={{__html: this.props.content }} />
                </SmoothCollapse>
            </div>
        );
    }
}

CollapsibleContent.propTypes = {
    openText: PropTypes.string.isRequired,
    closeText: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
};

CollapsibleContent.defaultProps = {
    closeText: 'Tap to close'
};

export default CollapsibleContent;


// WEBPACK FOOTER //
// ./src/components/Place/CollapsibleContent.js